/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import api from '../services/Api';

import SliderLoader from './loaders/SliderLoader';

const Sliders = ({ setLoadingSlide1 }) => {
  const [sliderItems, setSliderItems] = useState({
    loading: false,
    error: null,
    data: {
      status: true,
      result: [],
      message: null,
    },
  });

  const getData = async () => {
    setSliderItems({
      ...sliderItems,
      loading: true,
      error: null,
    });

    try {
      const data = await api.images.heroSlider();
      setSliderItems({
        loading: false,
        data,
      });
      setLoadingSlide1(false);
    } catch (error) {
      setSliderItems({
        loading: false,
        error,
      });
    }
  };

  useEffect(() => {
    getData();
  }, []);

  if (sliderItems.loading === true) {
    return <SliderLoader />;
  }

  return (
    <>
      {/* Si no hay elementos no se renderiza */}
      {sliderItems.data.result?.length === 0 && null}

      {/* Si hay un elemento solo muestra una imagen */}
      {sliderItems.data.result?.length === 1 && (
        <main className='hero'>
          <div className='hero__container'>
            {sliderItems.data.result?.map((slider, index) => (
              <div className='hero__items sladio__items' key={index}>
                {/* TODO : al ponerle una etiqueta 'a' y clickear no abre el link en mobile, puede ser q este interfiriendo un evento de touch */}
                <a
                  href={slider.pdf ? slider.pdf : slider.url}
                  target='_blank'
                  rel='noreferrer'
                  className='hero__items__image'
                >
                  <picture>
                    <source srcSet={slider.imagenDesktop} media='(min-width: 576px)' />

                    <source srcSet={slider.imagenMobile} media='(min-width: 300px)' />

                    <img loading='auto' src={slider.imagenDesktop} alt='placeholder' />
                  </picture>
                </a>
              </div>
            ))}
          </div>
        </main>
      )}

      {/* Si hay dos o mas muestra el slider */}
      {sliderItems.data.result?.length > 1 && (
        <main className='hero sladio' id='slider1'>
          <div className='hero__container sladio__container'>
            {sliderItems.data.result?.map((slider, index) => (
              <div className='hero__items sladio__items' key={index}>
                {/* TODO : al ponerle una etiqueta 'a' y clickear no abre el link en mobile, puede ser q este interfiriendo un evento de touch */}
                <a
                  href={slider.pdf ? slider.pdf : slider.url}
                  target='_blank'
                  rel='noreferrer'
                  className='hero__items__image'
                >
                  <picture>
                    <source srcSet={slider.imagenDesktop} media='(min-width: 576px)' />

                    <source srcSet={slider.imagenMobile} media='(min-width: 300px)' />

                    <img loading='auto' src={slider.imagenDesktop} alt='placeholder' />
                  </picture>
                </a>
              </div>
            ))}
          </div>
        </main>
      )}
    </>
  );
};

export default Sliders;
